import { render, staticRenderFns } from "./banjiSjDecSec.vue?vue&type=template&id=90ee03f2&scoped=true"
import script from "./banjiSjDecSec.vue?vue&type=script&lang=js"
export * from "./banjiSjDecSec.vue?vue&type=script&lang=js"
import style0 from "./banjiSjDecSec.vue?vue&type=style&index=0&id=90ee03f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ee03f2",
  null
  
)

export default component.exports